import React from 'react';
import { SUGGESTION_PREFIX } from '@shared/components/EmailFieldContent/EmailFieldContent.utils';
import { SuggestionWrapper, SuggestionLink } from './EmailSuggestion.styles';

export interface EmailSuggestionProps {
  suggestedEmail: string;
  onSuggestionClick: () => void;
}

export const EmailSuggestion = ({ suggestedEmail, onSuggestionClick }: EmailSuggestionProps) => (
  <SuggestionWrapper>
    {SUGGESTION_PREFIX}{' '}
    <SuggestionLink onClick={onSuggestionClick} type="button">
      {suggestedEmail}?
    </SuggestionLink>
  </SuggestionWrapper>
);
